export default __webpack_public_path__ + "6d348ef0bfff1a97a8beaefe0fd788a8.png";